/*
 * @package           Zorg CMS
 * @author            Dru
 * @copyright         Copyright (c) 2008 - 2023, Belder Interactive s.a.s.
 * @link              https://www.belder.com
 * @version           3.2
 */

if (document.querySelectorAll('.shortcode_gmap').length) {
	window.loadCss('/media/pa_bootstrap/leaflet/leaflet.css');
	window.loadCss('/media/pa_bootstrap/leaflet/MarkerCluster.css');
	window.loadCss('/media/pa_bootstrap/leaflet/MarkerCluster.Default.css');
	window.loadJs('/media/pa_bootstrap/leaflet/jquery-3.7.0.min.js', () => {
		window.loadJs('/media/pa_bootstrap/leaflet/leaflet.js', () => {
			window.loadJs('/media/pa_bootstrap/leaflet/leaflet.markercluster.js', () => {
				window.loadJs('/media/pa_bootstrap/leaflet/openstreetmaps.js', () => {
					$('.shortcode_gmap').each(function (k, el) {
						shortcode_openmap($(this).attr('id'));
					});
				});
			})
		})
	});
}
